import {
  SET_PAGE_TITLE,
  SET_PAGE_SUB_TITLE,
  SET_SITE_LANG,
  SET_SIDER_WIDTH,
} from "../_types";
import { hp } from "../../utils";

const initialState = {
  pageTitle: "Send SMS",
  pageSubTitle: "",
  lang: hp.getCookie("site_lang") || "en",
  siderWidth: 256,
};

const utilsReducer = (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
    case SET_PAGE_TITLE:
      return {
        ...state,
        pageTitle: action.title,
      };

    case SET_PAGE_SUB_TITLE:
      return {
        ...state,
        pageSubTitle: action.title,
      };
    case SET_SITE_LANG:
      return {
        ...state,
        lang: action.lang,
      };
    case SET_SIDER_WIDTH:
      return {
        ...state,
        siderWidth: action.width,
      };
  }
};

export default utilsReducer;
